<template>
    <div class="main-content">
      <!-- Page Header Start -->
      <PageHeader>
        <PageHeaderTitleContent>
          <TitleTextContent
            :titleText="paperTitle"
            :subTitleText="'Our Cyber Advisors have subject matter expertise across the cybersecurity spectrum. Our white papers provide deep dive views and in-depth analysis of various critical cyber topics. Please check out our technical assessments of key cybersecurity issues that will better inform you as you seek to protect your organization from cyber threats.'"
            :subTitleTextMdLgXlWidth="'70%'"
            :subTitleTextSmXsWidth="'75%'"
          />
        </PageHeaderTitleContent>
      </PageHeader>
      <!-- Page Header End -->
      <!-- Blog Grid Section Start -->
      <section class="section p-0 mt-5 section-content">
        <div class="container-fluid px-xs-1 px-md-5 px-lg-5">
          <div class="w-100 d-flex justify-content-center section-title">
            <span>READ OUR RESEARCH</span>
          </div>

          <!-- White Paper Search Start -->
          <div class="mb-5">
            <SearchControlWidget
              :inputTextPlaceholder="'Enter paper title here'"
              :searchControlHeight="'100px'"
              :searchControlWidth="'100%'"
              :searchQueryInputHandler="updateSearchQuery"
            />
          </div>
          <!-- White Paper Search End -->
  
          <div class="blog-post-grid row mb-4">
            <!-- Start White Paper Item -->
            <div
              class="col-12 col-md-6 col-lg-4 col-xl-4 mb-2"
              v-for="item in displayeditems"
              :key="item.id"
            >
              <div class="blog-item blog-grid-item h-100">
                <!-- <router-link
                  class="blog-post-image"
                  :to="{ 
                    name: 'white-paper-detail', 
                    query: { 
                      id: item.id, 
                      paperPage: String(currentPage),
                      query: searchQuery,
                      isRecentPapers: isRecentPapers,
                    }
                  }"
                > -->
                  <img
                    :src="item.imageURL"
                    :alt="item.photoDescription"
                    class="cover"
                  />
                <!-- </router-link> -->
                <div class="blog-post-info">
                  <h4 class="blog-post-title limit-lines-2">
                    {{ item.title }}
                  </h4>
                  <div class="d-flex align-items-center pb-2">
                    <!-- Imported methods from mixin -->
                    <div v-show="isRecentDate(item.date)" class="blog-info-meta text-dark text-start">
                      {{ getFormattedDate(item.date) }}
                    </div>
                  </div>
                  <p class="limit-lines-5">{{ item.headLine }}</p>
                  <div class="post-event-links d-flex align-items-center">
                    <!-- <router-link
                      class=""
                      :to="{
                        name: 'white-paper-detail',
                        query: { id: item.id },
                      }"
                    >
                      <a class="blog-info-meta link-underline">Read More</a>
                    </router-link> -->
                    <a
                      :href="item.whitepaperLink"
                      variant="link"
                      target="_blank"
                      >View White Paper</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- End White Paper Item -->
          </div>
  
          <div v-if="(totalRows > 0) && (totalRows > perPage)" class="mb-5">
            <b-pagination
              class="ml-0"
              id="blog-pagination"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              @page-click="pageClicked"
            ></b-pagination>
          </div>
    
          <div v-if="displayeditems.length === 0" style="height: auto;" class="row m-0 w-100 mb-4">
            <div class="col-12 p-0 d-flex justify-content-center align-items-center empty-blog-message text-center" v-html="whitePaperItems.length === 0 
              ? `There are no papers available within the last six months` 
              : `There are no research papers available for the search: 
                <br>
                &quot${searchQuery}&quot
                ` 
              ">
            </div>
          </div>
  
          <div v-if="isRecentPapers" class="d-flex flex-row justify-content-center mb-5">
            <v-btn
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="goToWhitePaperArchives"
            >
              View White Paper Archives
            </v-btn>
          </div>
          <div v-else class="d-flex flex-row justify-content-center mb-5">
            <v-btn
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="gotToRecentPapers"
            >
              Back To Recent
            </v-btn>
          </div>
        </div>
      </section>
      <!-- Blog Grid Section End -->
    </div>
  </template>
  <script>
  import debounce from "debounce";
  import { BPagination, BFormInput } from 'bootstrap-vue';
  import PageHeader from "../library/widgets/page-header.vue";
  import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
  import TitleTextContent from '../library/widgets/title-text-content.vue';
  import SearchControlWidget from '../library/widgets/search-control-widget.vue';
  import { EventBus } from '../../utils/eventBus';
  export default {
    name: 'blog',
    components: {
      BPagination,
      BFormInput,
      PageHeader,
      PageHeaderTitleContent,
      TitleTextContent,
      SearchControlWidget,
    },
    props: {
        paperTitle: String,
        whitePaperItems: Array,
        isRecentPapers: {
            type: Boolean,
            default: false,
        },
    },
    data() {
      return {
        searchQuery: null,
        itemCount: 0,
        currentPage: 1,
        isQueryFromUrl: false,
      };
    },
    computed: {
  
      itemsFromSearchQuery() {
        if (this.searchQuery) {
          return this.whitePaperItems.filter((item) => {
            return this.searchQuery
              .toLowerCase()
              .split(' ')
              .every(
                (v) => item.title.toLowerCase().includes(v)
              );
          });
        } else {
          return this.whitePaperItems;
        }
      },
      displayeditems() {
        return this.itemsFromSearchQuery.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage
        );
      },
      totalRows() {
        return this.itemsFromSearchQuery.length;
      },
      perPage() {
        return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md) ? 8 : 9
      }
    },
    mounted: function () {
        const urlDomain = this.isRecentPapers ? '/#/white-papers?' : '/#/white-papers-archives?';
        const urlParams = new URL( window.location.href.replace(urlDomain, '?') );
  
        const paperPage = urlParams.searchParams.get('paperPage');
        const query = urlParams.searchParams.get('query');
  
        this.isQueryFromUrl = query != undefined || query != null || query?.trim().length !== '';
        this.currentPage = paperPage ? parseInt(paperPage) : 1;
  
        EventBus.$emit("update-search-query", query);
    },
    methods: {
      pageClicked(bvEvent, page) {
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        const params = this.searchQuery === null || this.searchQuery === "null" || this.searchQuery?.trim() === ""
                        ? 
                          [
                            { param: 'paperPage', value: page }
                          ]
                        : 
                          [
                            { param: 'paperPage', value: page },
                            { param: 'query', value: this.searchQuery }
                          ];
        this.updateUrlQueryParam(
          this.isRecentPapers ? '#/white-papers' : '#/white-papers-archives', 
          params
        );
  
        setTimeout(() => {
          document
              .getElementById("search-query-control")
              .scrollIntoView({ behavior: "smooth", block: "start" });
        }, 500);
      },
      updateSearchQuery(searchText) {
        this.searchQuery = searchText;
      },
      goToWhitePaperArchives() {
        this.$router.push("white-papers-archives");
      },
      gotToRecentPapers() {
        this.$router.push("white-papers");
      },
    },
    watch: {
      searchQuery(newValue) {
        if(!this.isQueryFromUrl) {
            this.currentPage = 1;
        }
  
        debounce(
            () => {
              this.updateUrlQueryParam(
                this.isRecentPapers ? '#/white-papers' : '#/white-papers-archives', 
                [
                  { param: 'paperPage', value: this.currentPage }, 
                  { param: 'query', value: newValue } 
                ]
              );
            }, 
            1000, 
            { immediate: false }
          ).call(this);
  
        this.isQueryFromUrl = false;
      },
    }
  };
  </script>
  <style scoped>
  #blog-pagination li {
    margin: 0px;
  }
  
  .blog-post-info {
    padding: 0 20px 40px;
  }
  
  .cover {
    object-fit: cover;
    height: 225px;
    width: 100%;
  }
  
  .post-event-links {
    position: absolute;
    bottom: 15px;
  }
  
  .blog-grid-item {
    border-radius: 10px;
    border: 1px solid #272727;
    overflow: hidden;
  }
  
  .blog-post-image {
    border-bottom: 1px solid #d5d5d5;
  }
  
  .blog-item:hover .blog-post-image {
    border-bottom: 0;
  }
  
  .empty-blog-message {
    font-family: Rajdhani;
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    color: #272727;
    word-break: break-all;
  }
  </style>
  